import React, { Component } from 'react'
import BLrender from "../../common/bl_no";
import { Grid, Segment, Popup, Button, Icon, Label } from "semantic-ui-react";
import { Link } from "react-router-dom";
import GridPlaceholder from "./gridPlaceholder";
import moment from 'moment';
import 'moment-timezone';
import RouteManager from "./routeManager";
import LoadingPlaceholder from '../../placeholderComponent/loadingPlaceholder';
import { PROMPTS } from '../../../utils/validationConstant';

class ListingPageComponent extends Component {


    render() {
        const { t, listItems, shipmentData, path, isFetching, throttlerError, tryAgainDisabled } = this.props
        const reloadPage= ()=>{
            window.location.reload()
        }
        let content = ""
        return (
            <div
                className="animated slideInDown m-2 style"
                style={{ width: "99%", height: "100%", paddingBottom: "50px" }}
            >
                {listItems?.length > 0 ? (
                    listItems.map((item, index) => {
                        content = <BLrender id={item.order_id} />
                        return (
                            <Segment raised className="ml-3 mr-3" key={index} size="mini">
                                {item.vendor_interest_status ? (
                                    <>
                                        <Label className="mt-n5" color={item.vendor_interest_status.allotment_text == "Interested" ? "blue" : (item.vendor_interest_status.allotment_text == "Rebid Request" ? "yellow" : (item.vendor_interest_status.allotment_text == "Reject" ? "red" : "grey"))} ribbon='right'>
                                            {item.vendor_interest_status.allotment_text}
                                        </Label>
                                    </>
                                ) : (
                                    <Label ribbon='right' color="blue">
                                        {"Created"}
                                    </Label>
                                )}
                                <Link
                                    to={{
                                        pathname: path,
                                        state: { item, index },
                                        search: `?shipmentId=${item.order_id}`,
                                    }}
                                >
                                    <Grid columns={1} className="mt-1">
                                        <Grid.Row textAlign="center">
                                            <Grid.Column width={4} className="mt-n5">
                                                {/* <Grid columns="3">
                            <Grid.Row className="pb-0 pt-0">
                              <Grid.Column> */}
                                                <Label color='orange' className="ml-3" ribbon style={{ float: "left" }} >
                                                    {localStorage.getItem('customerNumber') == 1166 ? "Booking No" : t("list_view.order_no") || "Order No"} : {item.order_reference_no}
                                                </Label>
                                                <label className="w3-text-gray m-3 labelName text-nowrap">
                                                    {item.movement_type == "Import" || item.movement_type == "Importar" ? t("list_view.estimated_on") : t("list_view.required_on")}
                                                </label>
                                                <label className="p-bold-600 text-nowrap">
                                                    {moment.parseZone(item.required_on).format('DD-MM-YYYY HH:mm')}
                                                </label>
                                                <br />
                                                <label className="mr-3 w3-text-orange w3-medium p-bold-600 text-nowrap">
                                                    {item.broadcast_time_left}
                                                </label>
                                                {/* </Grid.Column>
                            </Grid.Row>
                          </Grid> */}
                                            </Grid.Column>
                                            <Grid.Column width={5} className="mt-n3">
                                                <RouteManager budgeted_kms={item.budgeted_kms} routeId={item.route_id} movement_type={item.movement_type} />
                                            </Grid.Column>
                                            <Grid.Column width={2} className="mt-n3">
                                                <Grid.Row className="pb-0 pt-0">
                                                    <label className="w3-text-gray labelName text-nowrap">
                                                        {t("list_view.offered_rate") || "Offered Rate"}
                                                    </label>
                                                </Grid.Row>
                                                {item.movement_type == "Primary" || item.movement_type == "Primário" ?
                                                    <Grid.Row className="pb-0 pt-0">
                                                        <label className="w3-text-gray labelName text-nowrap">
                                                            {"Temperature"}
                                                        </label>
                                                    </Grid.Row>
                                                    : ""}
                                                <Grid.Row className="pb-0 pt-0">
                                                    <label className="w3-text-gray labelName text-nowrap">
                                                        {t("list_view.gross_weight") || "Gross Weight"}
                                                    </label>
                                                </Grid.Row>
                                            </Grid.Column>
                                            <Grid.Column width={1} className="mt-n3">
                                                <Grid.Row className="pb-0 pt-0">
                                                    <label className="p-bold-600 text-nowrap ">
                                                        {item.offered_rate ? item.offered_rate + " " + (item.uom ? "/ " + item.uom : "") : "NA"}
                                                    </label>
                                                </Grid.Row>
                                                {item.movement_type == "Primary" || item.movement_type == "Primário" ?
                                                    <Grid.Row className="pb-0 pt-0">
                                                        <label className="p-bold-600 text-nowrap ">
                                                            {item.min_temp && item.max_temp ? item.min_temp + ' \u00b0' + "C" + " - " + item.max_temp + ' \u00b0' + "C" : "NA"}
                                                        </label>
                                                    </Grid.Row>
                                                    : ""}
                                                <Grid.Row className="pb-0 pt-0">
                                                    <label className="p-bold-600 text-nowrap">
                                                        {item.gross_weight ? item.gross_weight : "NA"}
                                                    </label>
                                                </Grid.Row>
                                                {/* <Grid.Row className="pb-0 pt-0">
                            <label className="p-bold-600 text-nowrap">
                              <BLrender id={item.order_id} />
                            </label>
                          </Grid.Row> */}
                                            </Grid.Column>
                                            <Grid.Column width={3} textAlign="right" className="mt-1">
                                                <div>
                                                    <span
                                                        className="sumo_truck_quantity"
                                                        style={{
                                                            width: "55px",
                                                            whiteSpace: "nowrap",
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis"
                                                        }}
                                                    >
                                                    </span>
                                                    <img src="assets/svg/sumo_truck.svg" alt="sumo_truck" width="50%" />
                                                </div>
                                                <label className="w3-text-blue bfonter mt-1">
                                                    {t("list_view.movement_type") || "Movement Type"} : &nbsp;
                                                    <span className="p-bold-600 movement_type">{item.movement_type ? item.movement_type : "NA"}</span>
                                                </label>
                                                {/* <div style={{ marginTop: "-10px" }}>
                            <label className="w3-text-blue bfonter">
                              {"Uom"} : &nbsp;
                          <span className="p-bold-600 movement_type">{item.uom ? item.uom : "NA"}</span>
                            </label>
                          </div> */}
                                            </Grid.Column>
                                            {/* <Grid.Column width={1}>
                          
                        </Grid.Column> */}

                                        </Grid.Row>
                                        {item.movement_type == "Import" || item.movement_type == "Importar" ?
                                            <Grid.Row className="mr-0 ml-0 p-2 footer-text">
                                                <span className="ml-5"> {t("list_view.bl_no") || "BL No."} :  </span>  <span className="ml-2"> <span>{item.bl_numbers != "" ? item.bl_numbers : "NA"}</span> </span>
                                            </Grid.Row>
                                            : ""}
                                    </Grid>
                                </Link>
                            </Segment>
                        );
                    })
                ) :
                    <>
                        { throttlerError && isFetching == false ? (
                            <div className='centeredErrorMsg'>
                            <h6>{throttlerError}</h6>
                            <Button type="button" disabled={tryAgainDisabled} color={!tryAgainDisabled && "blue"} className='w3-round mt-1' onClick={reloadPage}>{PROMPTS.TRY_AGAIN||"Try Again"}</Button>
                            </div>
                        ): 
                        (
                        listItems?.length == 0 && isFetching == false ? (
                            <div>{PROMPTS.NO_RECORDS_FOUND||"No Record(s) Found"}</div>
                        ) : (
                            <LoadingPlaceholder />
                        ))
                        }
                    </>
                }
            </div>
        )
    }
}

export default ListingPageComponent
